import { useContext, useEffect } from 'react';
import { isUndefined } from 'lodash-es';
import { useOtherSettings } from '@namespace/cms';
import { usePrevious } from '@namespace/helpers';
import { NOTIFICATION_TYPES } from '@namespace/notifications/src/constants';
import useNotifications from '@namespace/notifications/src/hooks/useNotifications';
import { NotificationContext } from '@namespace/notifications/src/store/context';
import { UserContext } from '../../context';
import { useStatuses } from '../useStatuses';
import getNotificationType from './utils/getNotificationType';

export { getNotificationType };

const INIT_NOTIFICATIONS_BLOCK_LIST = [NOTIFICATION_TYPES.VERIFIED_USER];

const useVerificationStatusNotification = () => {
  const { customNotification } = useNotifications();
  const { isVerificationBeforeLimitFlow = false } = useOtherSettings();
  const accountStatuses = useStatuses();
  const [user] = useContext(UserContext);
  const [{ priority, isPause }] = useContext(NotificationContext);

  const notificationType = getNotificationType({ accountStatuses, user });
  const prevNotificationType = usePrevious(notificationType);

  useEffect(() => {
    if (notificationType) {
      const isTypeChanged =
        notificationType !== prevNotificationType &&
        !isUndefined(prevNotificationType);

      const shouldShowNotification =
        isTypeChanged ||
        !INIT_NOTIFICATIONS_BLOCK_LIST.includes(notificationType);

      if (shouldShowNotification) {
        customNotification({
          notificationType,
          timeout: null,
          ...(notificationType === NOTIFICATION_TYPES.VERIFIED_USER &&
          isVerificationBeforeLimitFlow
            ? { priority: 2 }
            : {})
        });
      }
    }
  }, [
    notificationType,
    customNotification,
    priority,
    isPause,
    prevNotificationType
  ]);
};

export default useVerificationStatusNotification;
